import { render, staticRenderFns } from "./PivotTable.vue?vue&type=template&id=efce6f34&scoped=true&"
import script from "./PivotTable.vue?vue&type=script&lang=js&"
export * from "./PivotTable.vue?vue&type=script&lang=js&"
import style0 from "./PivotTable.vue?vue&type=style&index=0&id=efce6f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efce6f34",
  null
  
)

export default component.exports